import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { uniqueId } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { isEmpty } from 'lodash';
import { RainIcon } from '../../../assets/svg/Icon';

import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function RainList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, dataDetail, handleRainDetailList, handleOpenLegend, mobilemode,
  } = props;

  function renderList(dataList) {
    return (
      <>
        {dataList.map((row) => (
          <Grid item key={uniqueId()}>
            <Box className={`${classes.listsBox} ${classes[row.color.colorname]}`}>{row.name}</Box>
          </Grid>
        ))}
      </>
    );
  }
  function renderRain(rainYellow, rainRed) {
    return (
      <>
        {renderList(rainRed)}
        {renderList(rainYellow)}
      </>
    );
  }

  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewRainfall}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                {datas.count !== 0
                  ? (
                    <IconButton onClick={mobilemode ? null : handleRainDetailList(dataDetail)}>
                      <StyledBadge
                        id="main-rain-click"
                        badgeContent={datas.count}
                        overlap="circular"
                        color="secondary"
                      >
                        <RainIcon style={{ color: 'white' }} />
                      </StyledBadge>
                    </IconButton>
                  ) : (
                    <StyledBadge
                      id="main-rain-click"
                      badgeContent={datas.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <RainIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  )}
              </Box>
              <Box display="flex" alignItems="center" id="dialog_rainfall">
                <Box pl={1}>
                  <IconButton id="legend-rainfall" className={classes.btn} onClick={handleOpenLegend(t('เกณฑ์ฝน'), 'rainfall')}>
                    <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                  </IconButton>
                </Box>
                <Box p={1}>
                  <NavLink id="navigate_rainfall" to={`${initPath}rainfall`} activeClassName="nav-active">
                    <Typography className={classes.titleBox}>{t('ฝน')}</Typography>
                  </NavLink>
                </Box>
                <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_rainfall_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null : (
                  <>
                    {(datas.yellow.length <= 0 && datas.red.length <= 0) ? (
                      <Grid item>
                        <Box className={`${classes.listsBox}`} style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold' }}>{t('ปกติ')}</Box>
                      </Grid>
                    ) : renderRain(datas.yellow, datas.red)}
                  </>
                )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
RainList.defaultProps = {
  mobilemode: false,
};

RainList.propTypes = {
  datas: PropTypes.objectOf(Object).isRequired,
  dataDetail: PropTypes.instanceOf(Array).isRequired,
  handleRainDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
